<template>
  <div>
    <div
      class="line hover_op"
      :class="{ active: show_drop }"
      @click="show_drop = !show_drop"
      v-click-outside="hide"
    >
      <img :src="src" alt="" class="icon" v-if="with_img" />
      <div class="select" :title="selected_value">
        {{ selected_value }}
      </div>
      <img src="@/assets/img/drop_arrow.svg" alt="" class="arrow" />
    </div>

    <div class="drop" :class="{ active: show_drop }">
      <template v-for="option in options">
        <button
          class="hover_op"
          :key="option.deviceId"
          :class="{ active: option.active }"
          @click="
            (show_drop = !show_drop),
              (option.active = true),
              (selected_value = option.label),
              setDevice(option.deviceId)
          "
        >
          {{ option.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  data() {
    return {
      show_drop: false,
      selected_value: this.default_item,
    };
  },

  methods: {
    setDevice(id) {
      this.$emit("setDevice", id);
    },

    hide() {
      this.show_drop = false;
    },
  },

  props: {
    default_item: String,
    with_img: Boolean,
    src: String,
    options: [Array, Object],
    color: [Boolean, false],
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style scoped>
</style>